"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Hero = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _axios = _interopRequireDefault(require("axios"));

var _ImageUploader = _interopRequireDefault(require("@insided/deprecated-control/category/ImageUploader"));

var _panel = _interopRequireDefault(require("@insided/deprecated-control/panel"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _HeroImage = require("../image-uploading/HeroImage");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Hero = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Hero, _Component);

  var _super = _createSuper(Hero);

  function Hero(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Hero);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "uploader", void 0);
    _this.state = {
      // eslint-disable-next-line react/no-unused-state
      src: null,
      // eslint-disable-next-line react/no-unused-state
      crop: {
        x: 0,
        y: 0,
        width: 96,
        height: 16,
        aspect: 6
      },
      pixelCrop: {
        width: 96,
        height: 16,
        x: 0,
        y: 0
      },
      // eslint-disable-next-line react/no-unused-state
      errorMessage: null,
      hero_image: props.heroImage,
      headline: props.headline
    };
    _this.uploader = null;
    _this.saveImage = _this.saveImage.bind((0, _assertThisInitialized2.default)(_this));
    _this.cancelUpload = _this.cancelUpload.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Hero, [{
    key: "saveImage",
    value: function () {
      var _saveImage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var element, csrf, formData, file, res, source_thumb;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                element = document.querySelector('input#csrftoken');
                csrf = '';

                if (element !== null) {
                  csrf = element.value;
                }

                formData = new FormData();

                if (!(this.uploader === null)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                if (!(this.uploader.files === null)) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return");

              case 9:
                file = this.uploader.files[0];
                formData.append('image', file);
                formData.append('yip_csrf_token', csrf);
                formData.append('crop_coords[x]', Math.round(this.state.pixelCrop.x).toString());
                formData.append('crop_coords[y]', Math.round(this.state.pixelCrop.y).toString());
                formData.append('crop_coords[width]', Math.round(this.state.pixelCrop.width).toString());
                formData.append('crop_coords[height]', Math.round(this.state.pixelCrop.height).toString());
                _context.next = 18;
                return _axios.default.post('/attachment/new', formData);

              case 18:
                res = _context.sent;
                // eslint-disable-next-line @typescript-eslint/naming-convention
                source_thumb = res.data.source_thumb; // eslint-disable-next-line react/no-unused-state

                this.setState({
                  hero_image: source_thumb,
                  src: null
                });
                _context.next = 26;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context["catch"](0);
                // eslint-disable-next-line no-console
                console.log(_context.t0);

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 23]]);
      }));

      function saveImage() {
        return _saveImage.apply(this, arguments);
      }

      return saveImage;
    }()
  }, {
    key: "cancelUpload",
    value: function cancelUpload() {
      // eslint-disable-next-line react/no-unused-state
      this.setState({
        src: null
      });

      if (this.uploader) {
        this.uploader.value = '';
      }
    }
  }, {
    key: "componentWillUpdate",
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextProps.onChange && this.state !== nextState) {
        nextProps.onChange({
          hero_image: nextState.hero_image,
          headline: nextState.headline
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _window$inSidedData,
          _this2 = this;

      // eslint-disable-next-line @typescript-eslint/naming-convention
      var _this$state = this.state,
          headline = _this$state.headline,
          hero_image = _this$state.hero_image; // eslint-disable-next-line no-restricted-properties

      var isForum = (_window$inSidedData = window.inSidedData) === null || _window$inSidedData === void 0 ? void 0 : _window$inSidedData.communityId;
      return (0, _preact.h)("div", {
        className: "hero-banner-wrapper"
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Headline",
        name: "headline",
        placeholder: "Add a headline",
        type: "text",
        onChange: function onChange(event) {
          return _this2.setState({
            headline: event.target.value
          });
        },
        value: headline
      }), (0, _preact.h)("label", null, "Hero image"), (0, _preact.h)("p", null, "Maximum file size: 5m. Allowed image types: .jpg, .png, .gif. We recommend a minimum of 2880*480px"), (0, _preact.h)(_HeroImage.HeroImage, {
        src: (0, _absoluteUrlRuntime.resolveUrl)(hero_image),
        dimentionLabel: "2880px \xD7 480px",
        onEdit: function onEdit() {
          var _this2$uploader;

          return (_this2$uploader = _this2.uploader) === null || _this2$uploader === void 0 ? void 0 : _this2$uploader.click();
        },
        onRemove: function onRemove() {
          return _this2.setState({
            hero_image: ''
          });
        },
        onUpload: function onUpload() {
          var _this2$uploader2;

          return (_this2$uploader2 = _this2.uploader) === null || _this2$uploader2 === void 0 ? void 0 : _this2$uploader2.click();
        },
        buttonClassName: !isForum && 'btn-default',
        uploadButtonClassName: !isForum && 'btn-default btn-primary'
      }), (0, _preact.h)(_ImageUploader.default, {
        width: 2880,
        height: 480 // eslint-disable-next-line @typescript-eslint/naming-convention
        ,
        onUploaded: function onUploaded(_ref) {
          var source_thumb = _ref.source_thumb;
          return _this2.setState({
            hero_image: source_thumb
          });
        },
        uploaderRef: function uploaderRef(ref) {
          _this2.uploader = ref;
        }
      }));
    }
  }]);
  return Hero;
}(_preact.Component);

exports.Hero = Hero;

var HeroPanel = function HeroPanel(props) {
  return (0, _preact.h)(_panel.default, {
    collapsible: true,
    customClass: "homepage-widget",
    title: (0, _preact.h)("div", {
      className: "panel-title-with-switch"
    }, (0, _preact.h)("div", {
      className: "homepage-reorderable-panel-title"
    }, props.dragHandle, (0, _preact.h)("span", null, "Search Banner")), props.switcher)
  }, (0, _preact.h)(Hero, props));
};

var _default = HeroPanel;
exports.default = _default;